import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
/**
 * Legacy route `/billing/issue-invoice/tax-invoice`.
 * GST invoices are created automatically when an issued invoice is set to Invoiced on the Issued invoices list.
 */
function CompanyInvoice(props) {
  const navigate = useNavigate();
  return (
    <Box sx={{ p: 3, maxWidth: 640 }}>
      <Typography variant="h6" fontWeight={600} gutterBottom>
        Tax invoice is created automatically
      </Typography>
      <Typography variant="body2" color="text.secondary" paragraph>
        Use <strong>Issued invoices</strong>: move status <strong>Draft → Issued → Invoiced</strong>. When you set
        <strong> Invoiced</strong>, the system creates the GST bill that appears under <strong>Billing → Payments</strong>.
        Record partial or full payments there; the issued invoice status will follow as partial paid or paid.
      </Typography>
      <Button variant="contained" onClick={() => navigate('/billing/issue-invoice/list')}>
        Go to Issued invoices
      </Button>
      <Button sx={{ ml: 1 }} variant="outlined" onClick={() => navigate('/billing/payment/list')}>
        Go to Payments
      </Button>
    </Box>
  );
}

export default CompanyInvoice;
